"use client";

import { useState } from "react";
import Link from "next/link";

export function SiteHeader() {
  const [open, setOpen] = useState(false);
  return (
    <header className="site-header">
      <Link className="brand" href="/">TR<span>Registry</span></Link>
      <button
        type="button"
        className="nav-toggle"
        aria-expanded={open}
        aria-controls="primary-nav"
        onClick={() => setOpen((value) => !value)}
      >
        Menu
      </button>
      <nav id="primary-nav" aria-label="Primary navigation" hidden={!open}>
        <Link href="/trainers">Find trainers</Link>
        <Link href="/assignments">Assignments</Link>
        <Link href="/how-we-verify">How we verify</Link>
      </nav>
      <div className="header-actions"><Link href="/login">Sign in</Link><Link className="button small" href="/signup">Join the registry</Link></div>
    </header>
  );
}